import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useCentroCustoOutletContext } from 'pages/CentroCusto'
import { useParams } from 'react-router-dom'
import { centroCusto } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

export default function ExcluirCentroCusto() {
    const { id } = useParams()
    const { data } = useCentroCustoOutletContext()
    const node = data?.find(item => item.id === Number(id))
    const setCostCenterId = useStore(state => state.setCostCenterId)
    const { mutateAsync, isLoading } = centroCusto.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!node) return null

    const handleSubmit = () =>
        mutateAsync(node.id, {
            onSuccess: () => {
                toast.success('Centro de custo excluído com sucesso')
                setCostCenterId(-1)
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="auto"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'CentrosDeCusto'])}
        >
            <Dialog.Content>
                Realmente deseja excluir o centro custo {node.nomeCentroCusto}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
